/*!

 =========================================================
 * Vue Now UI Kit Pro - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-now-ui-kit-pro
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

Vue.config.devtools = true;
Vue.config.performance = true;

// Core Libary
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueGtag from "vue-gtag"; //Google Analytics

const routers = new VueRouter({
  routes: [
    { name: "index", path: "/" },
    { name: "About", path: "/about" }
  ]
});

//Google Analytics
Vue.use(
  VueGtag,
  {
    config: {
      id: "G-236LHEJG1G" // Google Analytics의 Tracking ID를 넣어준다
    },
    pageTrackerTemplate(to) {
      //페이지 변경 될 때마다 속성 보내기
      return {
        page_title: "amazing page",
        page_path: to.path
      };
    }
  },
  routers
);

//configure language i18 korean
import VueI18n from "vue-i18n";
import locale from "element-ui/lib/locale";
import koLocale from "element-ui/lib/locale/lang/ko";

Vue.use(VueI18n);

// Service Libary
import moment from "vue-moment";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import { Loading } from "element-ui";
import VueLazyload from "vue-lazyload";
Vue.use(Loading.directive);
Vue.use(VueLazyload, {
  preLoad: 15,
  error: "/img/svg/jipvio_error_image.svg",
  loading: "/img/VIO.png",
  attempt: 5,
  listenEvents: ["scroll"]
});

import "./registerServiceWorker";

//plugins
import NowUIKit from "./plugins/now-ui-kit";
import "@/assets/sass/now-ui-dashboard.scss";
import "@/assets/sass/jipvio-ui-kit.scss";
import VueRouter from "vue-router";

Vue.prototype.$store = store;
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["hoverunder"];
Vue.use(NowUIKit);
Vue.use(moment);
Vue.use(VueLodash, { lodash: lodash });

locale.use(koLocale);

//axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
// axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.interceptors.request.use(
  async function(config) {
    console.log(config);
    // if (process.env.NODE_ENV === "production") {
    // }

    if (config.url.length > 0 && config.url[0] === "/") {
      const sessionAuthToken = store.getters["loginSession/getAuthToken"];
      if (sessionAuthToken) {
        config.headers.common["X-Auth-Token"] = sessionAuthToken;
      }
    } else {
      const url = new URL(config.url);
      if (
        url.host !== "developers.kakao.com" &&
        url.host !== "dapi.kakao.com"
      ) {
        const sessionAuthToken = store.getters["loginSession/getAuthToken"];
        if (sessionAuthToken) {
          config.headers.common["X-Auth-Token"] = sessionAuthToken;
        }
      }
    }

    // gloval request - token
    // config.headers.common['X-Auth-Token'] = token;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// API interceptor for response
/*
axios.interceptors.response.use(
  function(response) {
    // global response
    return response;
  },
  function(error) {
    console.log("====h2");
    console.log(error);
    return error;
  }
);
*/

// Vue instance
const v = new Vue({
  render: h => h(App),
  router,
  store
});

// Communication tool with Juso solution
window.app = v;

v.$mount("#app");
